var _rect, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.199219,
    width: 60,
    height: 60,
    rx: 16,
    fill: "#26B0EB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.1992 41.667V19.667C45.1992 17.4579 43.4084 15.667 41.1992 15.667H19.1992C16.9901 15.667 15.1992 17.4579 15.1992 19.667V41.667C15.1992 43.8761 16.9901 45.667 19.1992 45.667H41.1992C43.4084 45.667 45.1992 43.8761 45.1992 41.667Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2812 25.25C22.2812 24.5596 22.8409 24 23.5312 24H36.8646C37.5549 24 38.1146 24.5596 38.1146 25.25C38.1146 25.9404 37.5549 26.5 36.8646 26.5H23.5312C22.8409 26.5 22.2812 25.9404 22.2812 25.25Z",
    fill: "#26B0EB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2812 31.0835C22.2812 30.3931 22.8409 29.8335 23.5312 29.8335H36.8646C37.5549 29.8335 38.1146 30.3931 38.1146 31.0835C38.1146 31.7739 37.5549 32.3335 36.8646 32.3335H23.5312C22.8409 32.3335 22.2812 31.7739 22.2812 31.0835Z",
    fill: "#26B0EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2812 36.917C22.2812 36.2266 22.8409 35.667 23.5312 35.667H30.1979C30.8883 35.667 31.4479 36.2266 31.4479 36.917C31.4479 37.6073 30.8883 38.167 30.1979 38.167H23.5312C22.8409 38.167 22.2812 37.6073 22.2812 36.917Z",
    fill: "#26B0EB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5312 13H26.8646C25.0236 13 23.5312 14.3431 23.5312 16C23.5312 17.6569 25.0236 19 26.8646 19H33.5312C35.3722 19 36.8646 17.6569 36.8646 16C36.8646 14.3431 35.3722 13 33.5312 13Z",
    fill: "#BEECFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.d4ba158c060ea4ba5fe89e11c3970296.svg";
export { ForwardRef as ReactComponent };